<template>
    <div class="team-edit">
        <div class="full-container">
            <div class="top-navbar">
                <div class="row align-items-center">
                    <div class="col-md-4">
                        <div class="top-navbar-left">
                            <div class="btn-back" @click="$router.push({ name: 'teamDetails' });">
                                <font-awesome-icon :icon="['fas', 'angle-left']" />
                                Back
                            </div>
                        </div>
                    </div> 
                    
                    <div class="col-md-4">
                        <div class="top-navbar-center">
                            Edit Team
                        </div>
                    </div>
                </div>
            </div>

            <hr />
        </div>
        <div class="container ">
            <h3 class="section-title mt-5">Team Details</h3>

            <div class="custom-alert alert alert-success" role="alert" v-if="isSuccess">
                Team updated successfully.
            </div>
            <div class="custom-alert alert alert-danger" role="alert" v-if="isError">
                Please fill in the mandatory field(s).
            </div>

            <form @submit.prevent="checkForm" action="#" method="post">
                <div class="row">
                    <div class="col-md-3">
                        <div class="form-group" :class="{ 'form-is-error': $v.teamData.program_id.$error }">
                            <label for="">Programme</label>

                            <select class="custom-select form-control" v-model.trim="$v.teamData.program_id.$model"  name="program" id="program">
                                <option v-for="program in programsData" v-bind:key="program.id" :value="program.id">{{program.name}}</option>
                            </select>

                            <div class="invalid-feedback form-error-msg" v-if="!$v.teamData.program_id.required">Programme is required</div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group" :class="{ 'form-is-error': $v.teamData.name.$error }">
                            <label for="">Team name *</label>
                            <input class="form-control" v-model.trim="$v.teamData.name.$model" type="text">
                            <div class="invalid-feedback form-error-msg" v-if="!$v.teamData.name.required">Team name is required</div>
                        </div>
                    </div>

                    <div class="col-md-6">
                        <div class="form-group" :class="{ 'form-is-error': $v.teamData.valid.$error }">
                            <label for="">Validity *</label>
                            
                            <div>
                                <div class="custom-control-inline pill-radio">
                                    <input v-model.trim="$v.teamData.valid.$model" id="valid" type="radio" name="validity" value="1" required class="custom-control-input">
                                    <label class="" for="valid">Valid</label>
                                </div>
                                <div class="custom-control-inline pill-radio">
                                    <input v-model.trim="$v.teamData.valid.$model" id="invalid" type="radio" name="validity" value="0" required class="custom-control-input">
                                    <label class="" for="invalid">Invalid</label>
                                </div>
                            </div>

                            <div class="invalid-feedback form-error-msg" v-if="!$v.teamData.valid.required">Validity is required</div>
                        </div>
                    </div>
                </div>
                <div class="row" v-if="tlData.length > 0">
                    <div class="col-md-4">
                        <div class="form-group" :class="{ 'form-is-error': $v.teamData.tl_id.$error }">
                            <label for="">Team Leader *</label>

                            <app-multi-select 
                                :options="tlData.map(tl => tl.user_id)"
                                :custom-label="opt => tlData.find(x => x.user_id == opt).name"
                                placeholder="Select Team Leader"
                                v-model="teamData.tl[0].user_id">

                            </app-multi-select>

                            <div class="invalid-feedback form-error-msg" v-if="!$v.teamData.tl_id.required">Team leader is required</div>
                        </div>    
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-3">
                        <div class="form-group" :class="{ 'form-is-error': $v.teamData.division.$error }">
                            <label for="">Division *</label>

                            <div>
                                <div class="custom-control-inline pill-radio">
                                    <input v-model.trim="$v.teamData.division.$model" type="radio" id="north" name="division" value="0" required class="custom-control-input" :disabled="isDivisionRestrict" @change="onChangeDivision()">
                                    <label class="" for="north">East</label>
                                </div>

                                <div class="custom-control-inline pill-radio">
                                    <input v-model.trim="$v.teamData.division.$model" type="radio" id="south" name="division" value="1" required class="custom-control-input" :disabled="isDivisionRestrict" @change="onChangeDivision()">
                                    <label class="" for="south">West</label>
                                </div>
                            </div>

                            <div class="invalid-feedback form-error-msg" v-if="!$v.teamData.division.required">Division is required</div>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="form-group" :class="{ 'form-is-error': $v.teamData.region_id.$error }">
                            <label for="">Region *</label>
                            <select class="custom-select form-control" v-model.trim="$v.teamData.region_id.$model" name="region" id="region" required :disabled="isRegionRestrict" @change="onChangeRegion()">
                                <option v-for="region in regionOptions" v-bind:key="region.id" :value="region.id">{{region.name}}</option>
                            </select>

                            <div class="invalid-feedback form-error-msg" v-if="!$v.teamData.region_id.required">Region is required</div>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="form-group" :class="{ 'form-is-error': $v.teamData.area_id.$error }">
                            <label for="">Primary Area *</label>
                            <select class="custom-select form-control" v-model.trim="$v.teamData.area_id.$model" name="area" id="area" required :disabled="isAreaRestrict">
                                <option v-for="area in areaOptions" v-bind:key="area.id" :value="area.id">{{area.name}}</option>
                            </select>

                            <div class="invalid-feedback form-error-msg" v-if="!$v.teamData.area_id.required">Primary area is required</div>
                        </div>
                    </div>
                </div>

                <h3 class="section-title mt-5">Team BA</h3>

                <div class="form-group">
                    <label for="">Selected BA</label>

                    <label class="float-right">Total selected: {{teamData.users ? teamData.users.length : 0}}</label>
                    
                    <div class="form-control selected-ba">
                        <div class="tag removable" v-for="ba in teamData.users" v-bind:key="ba.id" @click="removeCheckedBa(ba.id)">{{ba.name}}</div>
                    </div>
                </div>

                <div>
                    <div class="row justify-content-end mb-3">
                        <div class="col-md-3">
                            <select class="custom-select form-control" name="default-area-id" id="default-area-id"  @change="usersWithTeam()" v-model="primaryAreaId" required :disabled="isAreaRestrict">
                                <option v-for="area in areas" v-bind:key="area.id" :value="area.id">{{area.name}}</option>
                            </select>
                        </div>
                    </div>

                    <div class="ba-wrapper">
                        <table class="table table-hover">
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>Name</th>
                                    <th>Staff ID</th>
                                    <th>Primary Area</th>
                                    <th>Current Area</th>
                                    <th>User Status</th>
                                    <th>Current Team</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr id='checkbox' v-for="bas in basData" :key="bas.id" :class="{ disabled: checkDisabled(bas.team_id) }">
                                    <td>
                                        <div class="custom-control custom-checkbox">
                                            <input class="custom-control-input" type="checkbox" :id="bas.id+'-id'" :value="bas" v-model="teamData.users" :checked="true">
                                            <label class="custom-control-label" :for="bas.id+'-id'"></label>
                                        </div>
                                    </td>
                                    <td><label :for="bas.id+'-id'">{{bas.name}}</label></td>
                                    <td>{{bas.staff_id}}</td>
                                    <td>{{bas.primary_area_name}}</td>
                                    <td>{{bas.current_area_name}}</td>
                                    <td>{{bas.user_type}}</td>
                                    <td v-if="bas.team_name">{{bas.team_name}}</td>
                                    <td v-else>-</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                
                <button class="btn btn-ecdc btn-shadow">Save</button>
                <button type="button" class="btn btn-link" @click="$router.push({ name: 'teamDetails' });">Cancel</button>

            </form>
        </div>
        <app-loader v-show="isLoading"></app-loader>
    </div>
</template>

<script>
import { getTeam, getAreas, getRegions, getTlWithTeam, usersWithTeam, updateTeam, getPrograms, checkPermission } from '../api'
import { getAuth, getProj } from '../helpers'
import Loader from './Loader.vue'
import { required } from 'vuelidate/lib/validators'
import Multiselect from 'vue-multiselect'

export default {
    components: {
        appLoader: Loader,
        appMultiSelect: Multiselect
    },
    data() {
        return {
            teamData: "",
            tlData: "",
            basData: "",
            areas: "",
            areaOptions: "",
            regions: "",
            regionOptions: "",
            programsData: "",
            primaryAreaId: getAuth()['areaId'],
            defaultAreaId: getAuth()['areaId'],
            defaultRegionId: getAuth()['regionId'],
            defaultDivision: getAuth()['division'],
            defaultProject: getProj()['projId'],
            isDivisionRestrict: true,
            isRegionRestrict: true,
            isAreaRestrict: true,
            defaultTeamLeader: 0,
            isLoading: true,
            isError: false,
            isSuccess: false,
            id: 0
        }
    },
    validations: {
        teamData: {
            program_id: {
                required
            },
            name: {
                required
            },
            valid: {
                required
            },
            area_id: {
                required
            },
            region_id: {
                required
            },
            division: {
                required
            },
            tl_id: {
                required
            }
        }
    },
    async mounted() {

        this.id = this.$route.params.id;
        await this.getTeam();
        await this.getAreas();
        await this.getRegions();
        await this.getPrograms();
        await this.getTlWithTeam();
        this.isDivisionRestrict = await this.checkPermission('restrict division');
        this.isRegionRestrict = await this.checkPermission('restrict region');
        this.isAreaRestrict = await this.checkPermission('restrict area');

        this.isLoading = false;
    },
    methods: {
        async getTeam() {

            if (this.id == 0) {

                this.usersWithTeam();
                return;
            }
            
            try {

                const result = await getTeam(this.id);
                this.teamData = result.data.data;

                if (this.teamData.tl != null && this.teamData.tl.length > 0) {
                    this.teamData.tl_id = this.teamData.tl[0].user_id;
                }

                this.usersWithTeam();
            }
            catch(err) {

                alert(err.response.message);

            }
        },
        async getAreas() {

            try {
                const result = await getAreas();
                this.areas = result.data.data;
                this.areaOptions = this.areas;
            }
            catch(err) {

                alert(err.response.data.message);
            }
        },
        async getRegions() {

            try {
                const result = await getRegions();
                this.regions = result.data.data;
                this.regionOptions = this.regions;
            }
            catch(err) {
                alert(err.response.data.message);
            }
        },
        async getTlWithTeam() {

            try {
                const result = await getTlWithTeam(this.id);
                this.tlData = result.data.data.result;
                
            }
            catch(err) {
                alert(err.response.data.message);
            }
        },
        async getPrograms() {

            try {
                const result = await getPrograms(this.defaultProject)
                this.programsData = result.data.data;
            }
            catch(err) {
                alert(err.response.data.message);
            }
        },
        async usersWithTeam() {

            try {
                const result = await usersWithTeam(this.primaryAreaId);
                this.basData = result.data.data.result;
            }
            catch(err) {
                alert(err.response.data.message);
            }
        },
        async checkForm() {
            
            const _this = this;

            this.$v.teamData.$touch();

            if(this.$v.teamData.$invalid) {

                this.isError = true;
                window.scrollTo(0, 0);

                setTimeout(function() { 
                    
                    _this.isError = false;
                }, 2000);
            }
            else {

                this.isLoading = true;

                try {
                    this.teamData.project_id = this.defaultProject;
                    if (this.teamData.tl != null && this.teamData.tl.length > 0) {
                        this.teamData.tl_id = this.teamData.tl[0].user_id;
                    }
                    await updateTeam(this.teamData);

                    this.isSuccess = true;
                    window.scrollTo(0, 0);

                    setTimeout(function() { 
                        
                        _this.isSuccess = false;
                        _this.$router.push({ name: "teamDetails" });
                    }, 2000);
                }
                catch(err) {
                    alert(err.response.data.message);
                }

                this.isLoading = false;
            }
        },
        checkDisabled(id) {
            
            if(id == this.id) {
                return false;
            } else if(id == null) {
                return false;
            } else {
                return true;
            }
        },
        async checkPermission(permission) {

            try {
                const result = await checkPermission({permission:permission});
                return result.data.data;
            }    
            catch(err) {

                return true;
            }
        },
        onChangeDivision() {
            
            const _this = this;
            this.regionOptions = [];
            this.teamData.region_id = "";
            this.areaOptions = this.areas;
            this.teamData.area_id = "";

            if(this.teamData.division) {

                const found = this.regions.filter(value => value.division == this.teamData.division);

                found.forEach(value => {
                    _this.regionOptions.push(value);
                });
            }
            else {

                this.regionOptions = this.regions;
            }
        },
        onChangeRegion() {
            
            const _this = this;
            this.areaOptions = [];
            this.teamData.area_id = "";

            if(this.teamData.region_id) {

                const found = this.areas.filter(value => value.region_id == this.teamData.region_id);
                
                found.forEach(value => {
                    _this.areaOptions.push(value);
                });
            }
            else {

                this.areaOptions = this.areas;
            }
        },
        removeCheckedBa(baId) {

            const removeBa = this.teamData.users.map(value => value.id).indexOf(baId);
            this.teamData.users.splice(removeBa, 1);
        }
    }
}
</script>